module.exports = __webpack_public_path__ + "img/c-en-14.862204bd.png";